/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
import type { ShareUserAccessCampaignDetails } from './ShareUserAccessCampaignDetails';
import {
    ShareUserAccessCampaignDetailsFromJSON,
    ShareUserAccessCampaignDetailsFromJSONTyped,
    ShareUserAccessCampaignDetailsToJSON,
} from './ShareUserAccessCampaignDetails';

/**
 *
 * @export
 * @interface CampaignUserAccessResponseDto
 */
export interface CampaignUserAccessResponseDto {
    /**
     *
     * @type {Array<ShareUserAccessCampaignDetails>}
     * @memberof CampaignUserAccessResponseDto
     */
    campaigns?: Array<ShareUserAccessCampaignDetails> | null;
}

/**
 * Check if a given object implements the CampaignUserAccessResponseDto interface.
 */
export function instanceOfCampaignUserAccessResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CampaignUserAccessResponseDtoFromJSON(json: any): CampaignUserAccessResponseDto {
    return CampaignUserAccessResponseDtoFromJSONTyped(json, false);
}

export function CampaignUserAccessResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CampaignUserAccessResponseDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        campaigns: !exists(json, 'campaigns')
            ? undefined
            : json['campaigns'] === null
            ? null
            : (json['campaigns'] as Array<any>).map(ShareUserAccessCampaignDetailsFromJSON),
    };
}

export function CampaignUserAccessResponseDtoToJSON(
    value?: CampaignUserAccessResponseDto | null,
): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        campaigns:
            value.campaigns === undefined
                ? undefined
                : value.campaigns === null
                ? null
                : (value.campaigns as Array<any>).map(ShareUserAccessCampaignDetailsToJSON),
    };
}
